import axios from "axios";
import {authHeader, jsonAuthHeader} from "./auth-header";
import {ADMIN_API_URL, COMPUTING_ADMIN_API_URL} from "../containers/canopia/CanopiaUtils";

class AdminService {

    async reload(clientId) {
        // Create an object of formData
        const formData = new FormData();
        formData.append(
            "clientId", clientId ? clientId : 0
        );
        return axios.post(ADMIN_API_URL + "reload",
            formData,
            {headers: authHeader(), cache: 'no-store'}); // set the auth header as the register process is not public on server side
    }

    async run(clientIds, dateStr, consensusId, unpublish, runType, reviewType, reviewFileName, skipReview, notifyReviewer) {
        return axios.post(COMPUTING_ADMIN_API_URL + "run",
            {
                clientIds,
                dateStr,
                consensusId,
                unpublish,
                runType,
                reviewType,
                reviewFileName,
                skipReview,
                notifyReviewer
            },
            {
                headers: authHeader(), // set the auth header as the register process is not public on server side
                cache: 'no-store'
            });
    }

    async importConsensus(files, dateStr) {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        for (let i = 0; i < files.length; i++) {
            formData.append(
                `files`, files[i]
            );
        }
        formData.append(
            "dateStr", dateStr
        );

        return axios.post(COMPUTING_ADMIN_API_URL + "import/consensus",
            formData,
            {headers: authHeader(), cache: 'no-store'});
    }

    async importBM(files, persist, overwrite) {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        for (let i = 0; i < files.length; i++) {
            formData.append(
                `files`, files[i]
            );
        }
        formData.append(
            "persist", persist
        );
        formData.append(
            "overwrite", overwrite
        );

        return axios.post(COMPUTING_ADMIN_API_URL + "import/bm",
            formData,
            {headers: authHeader(), cache: 'no-store'});
    }

    async importRE(files, clientId, dateStr) {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "file",
            files[0]
        );
        formData.append(
            "clientId", clientId
        );
        formData.append(
            "dateStr", dateStr
        );
        return axios.post(ADMIN_API_URL + "import/re",
            formData,
            {headers: authHeader(), cache: 'no-store', encType: 'multipart/form-data'});
    }

    async importFund(files, source) {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        for (let i = 0; i < files.length; i++) {
            formData.append(
                `files`, files[i]
            );
        }
        formData.append(
            "source", source
        );

        return axios.post(COMPUTING_ADMIN_API_URL + "import/fund",
            formData,
            {headers: authHeader(), cache: 'no-store'});
    }

    // async saveStream(stream) {
    //     let content = [];
    //     stream.on(data => {
    //         content.push(data);
    //     })
    //     return axios.post(API_URL + "save/file",
    //         {content: content.join('')},
    //         {headers: authHeader(), cache: 'no-store'});
    // }

    async importGC(files) {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "file",
            files[0]
        );

        return axios.post(COMPUTING_ADMIN_API_URL + "import/gc",
            formData,
            {headers: authHeader(), cache: 'no-store', encType: 'multipart/form-data'});
    }

    async saveSetup(params) {
        return axios.post(ADMIN_API_URL + "setup/save",
            JSON.stringify(params),
            {headers: jsonAuthHeader(), cache: 'no-store'});
    }

    async saveGlobalParams(params) {
        return axios.post(ADMIN_API_URL + "setup/save-params",
            JSON.stringify(params),
            {headers: jsonAuthHeader(), cache: 'no-store'});
    }

    async loadClientDates(params) {
        return axios.post(ADMIN_API_URL + "client-dates",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
        // .then(response => {
        //     let contentType = response.headers.get("content-type");
        //     if (contentType && contentType.indexOf("application/json") !== -1) {
        //         return response.json();
        //     } else {
        //         console.log("The content type is not JSON, found " + contentType);
        //     }
        // })
        // .then(json => json)
        // .catch(error => error)
    }

    async loadSources() {
        return axios.get(ADMIN_API_URL + "sources",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
    }

    async loadLastFundScan() {
        return axios.get(COMPUTING_ADMIN_API_URL + "last-fund-scan",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
    }

    async loadConsensusList(params) {
        return axios.post(ADMIN_API_URL + "consensus-list",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
    }

    async saveClientInfo(params) {
        return axios.post(ADMIN_API_URL + "setup/save-client-info",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
    }

    async importInstruments() {
        return axios.post(COMPUTING_ADMIN_API_URL + "import/instruments", {}, {
            headers: authHeader(),
            cache: 'no-store'
        });
    }

    fundScan(params) {
        return axios.post(COMPUTING_ADMIN_API_URL + "fund-scan",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            })
    }

    getLookthroughAccessRequest(params) {
        return axios.post(COMPUTING_ADMIN_API_URL + "setup/get-look-through-access-request",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            });
    }

    sendLookthroughAccessRequest(params) {
        return axios.post(COMPUTING_ADMIN_API_URL + "setup/create-look-through-access-request",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            });
    }

    getPredefinedView(params) {
        return axios.post(COMPUTING_ADMIN_API_URL + "setup/get-predefined-view",
            JSON.stringify(params),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            });
    }

    async loadUsers() {
        return axios.get(ADMIN_API_URL + "users",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            });
    }

    async loadUserClients(userId) {
        return axios.get(ADMIN_API_URL + "user-clients",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store',
                params: {userId}
            });
    }

    async saveUserClients(userId, clientIds) {
        return axios.post(ADMIN_API_URL + "save-user-clients",
            JSON.stringify({userId, clientIds}),
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            });
    }

    async getFundSubstitutions() {
        return axios.get(ADMIN_API_URL + "fund-substitution",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store'
            });
    }

    async loadFundScanDetails(clientId) {
        return axios.get(COMPUTING_ADMIN_API_URL + "fund-scan-details",
            {
                headers: jsonAuthHeader(),
                cache: 'no-store',
                params: {clientId}
            });
    }
}

const adminService = new AdminService();
export default adminService;
